module.exports = __webpack_public_path__ + "assets/img/F3.2e7dfea0.png";